module.exports = __webpack_public_path__ + "img/162100.cf2e2c8f.jpg";